<script setup lang="ts">
import { useMobileStore } from '@/store/mobile';
import type { SidebarMenu } from '@/types/SidebarMenu';
import AppTypography from '../base/AppTypography.vue';

interface MenuListProp {
  items: SidebarMenu[];
}

defineProps<MenuListProp>();

const { showMenu } = storeToRefs(useMobileStore());
</script>

<template>
  <v-list class="py-0 mb-6">
    <v-list-item
      v-for="item in items"
      :key="item.title"
      :title="item.title"
      :class="item.class"
      class="pa-0 pr-2"
      height="56"
      :to="item.to || undefined"
      @click="item.action ? item.action() : (showMenu = false)"
    >
      <template #title="{ title }">
        <AppTypography element="span" type="body-1" class="font-weight-regular">
          {{ title }}
        </AppTypography>
      </template>

      <template v-if="item.icon" #prepend>
        <v-icon
          v-if="item.icon.startsWith('mdi-')"
          :icon="item.icon"
          class="mr-3"
          size="22"
          color="-primary"
        />
        <img v-else :src="item.icon" class="mr-3 menu-item-icon-img" alt="" />
      </template>

      <template #append>
        <div class="d-flex align-center ga-2">
          <v-badge v-if="item.badge" :content="item.badge" color="primary" inline />
          <v-btn
            color="-tertiary"
            density="compact"
            :loading="item.loading"
            :icon="item.iconAppend || 'mdi-chevron-right'"
            variant="text"
          />
        </div>
      </template>
    </v-list-item>
  </v-list>
</template>

<style lang="scss" scoped>
.v-list-item {
  &:not(:last-child) {
    border-bottom: 1px solid rgb(var(--v-theme-stroke));
  }

  &:hover,
  &.v-list-item--active {
    :deep(.v-list-item__overlay) {
      opacity: 0;
    }
  }

  .v-list-item__append > .v-btn,
  .v-list-item__prepend > .v-badge .v-icon,
  .v-list-item__prepend > .v-icon,
  .v-list-item__append > .v-badge .v-icon,
  .v-list-item__append > .v-icon {
    opacity: var(--v-medium-emphasis-opacity) !important;
  }

  :deep(.mdi-open-in-new) {
    font-size: 20px;
  }
}
</style>
